/**
 * Staging environment injected at deploy time via tools/deploy/inject-prod-env.mjs
 */
export const environment = {
  production: false,
  apiBaseUrl: 'https://dev-api-lance-x.onrender.com',
  publicBaseUrl: 'https://dev-lance-x.pages.dev',
  suporte: {
    whatsapp: 'REPLACE_AT_DEPLOY',
    email: 'suporte-dev@lance-x.app',
    tel: 'REPLACE_AT_DEPLOY',
  },
  firebaseWeb: {
    "apiKey": "REPLACE_AT_DEPLOY",
    "authDomain": "",
    "projectId": "",
    "messagingSenderId": "",
    "appId": "",
    "vapidKey": "REPLACE_AT_DEPLOY"
},
  appleNative: {
    clientId: 'app.lancex.mobile',
    redirectURI: 'https://dev-api-lance-x.onrender.com/auth/apple/callback',
  },
};
